import Vue from 'vue';
import { translation } from '@/plugins/i18n';
import { getCurrentSoftBundleName, getSoftBundleMessages } from '@/views/config/soft-bundle/helper';

// pop up message with coupon
export const softBundlePopUpMsgWithCoupon = () => {
  const bundleName = getCurrentSoftBundleName();
  const name = getSoftBundleMessages(bundleName)?.name ?? bundleName;
  const message = translation('softBundle.incompatibleForCouponTips', [translation(name)]);
  return Vue.prototype.$message({ message, dangerouslyUseHTMLString: true, type: 'warning', duration: 5000 });
}
